// Y-axis labels for the time grid.
import { Box } from '@mui/material';

const TimeLabelColumn = ({ hourlyLabels, firstHourLabelRef }) => {
  return (
    <Box
      data-testid="time-label-column"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        position: 'sticky',
        left: 0,
        zIndex: 5,
        bgcolor: 'background.paper',
        width: 48,
        flexShrink: 0,
        alignSelf: 'flex-start',
      }}
    >
      <Box
        sx={{
          height:
            'calc(var(--plan-day-header-height) + var(--plan-allday-row-height) + var(--plan-day-column-border))',
          flexShrink: 0,
        }}
      />
      {hourlyLabels.map((label, index) => (
        <Box
          key={label}
          ref={index === 0 ? firstHourLabelRef : null}
          sx={{
            height: 'var(--hour-label-height)',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-end',
            pr: '6px',
            fontSize: '0.75em',
            color: 'text.subtle',
            borderBottom: 1,
            borderColor: 'grey.200',
            boxSizing: 'border-box',
            flexShrink: 0,
          }}
        >
          {label}
        </Box>
      ))}
    </Box>
  );
};

export default TimeLabelColumn;
